import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'

const IconFilterGroup = ({ className }) => {
  return (
    <svg
      width='85'
      height='85'
      viewBox='0 0 85 85'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M42.5 85C65.9721 85 85 65.9721 85 42.5C85 19.0279 65.9721 0 42.5 0C19.0279 0 0 19.0279 0 42.5C0 65.9721 19.0279 85 42.5 85Z'
        fill='white'
      />
      <path
        d='M25.4402 38.49V36C25.4508 31.6734 27.1791 27.5281 30.245 24.4753C33.3109 21.4225 37.4636 19.712 41.7902 19.72C50.9402 19.91 59.0002 27 59.0002 35.94C58.9441 37.4735 58.7023 38.9946 58.2802 40.47C57.06 44.1798 55.066 47.5883 52.4302 50.47L54.8002 65.92H38.5702L37.0002 61.71L29.7202 61.49C29.1025 61.3955 28.533 61.1005 28.0994 60.6506C27.6657 60.2007 27.392 59.6208 27.3202 59L26.1702 49L21.2402 47.46L25.4402 38.52'
        fill='#D8D8D8'
      />
      <path
        d='M25.4402 38.49V36C25.4508 31.6734 27.1791 27.5281 30.245 24.4753C33.3109 21.4225 37.4636 19.712 41.7902 19.72V19.72C50.9402 19.91 59.0002 27 59.0002 35.94C58.9441 37.4735 58.7023 38.9946 58.2802 40.47C57.06 44.1798 55.066 47.5883 52.4302 50.47L54.8002 65.92H38.5702L37.0002 61.71L29.7202 61.49C29.1025 61.3955 28.533 61.1005 28.0994 60.6506C27.6657 60.2007 27.392 59.6207 27.3202 59L26.1702 49L21.2402 47.46L25.4402 38.52'
        stroke='#5A5654'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M53.7901 42.98C61.4779 42.98 67.7101 36.7478 67.7101 29.06C67.7101 21.3722 61.4779 15.14 53.7901 15.14C46.1023 15.14 39.8701 21.3722 39.8701 29.06C39.8701 36.7478 46.1023 42.98 53.7901 42.98Z'
        fill='white'
      />
      <path
        d='M61.1001 30.74L63.7601 30.39V27.73L61.0901 27.38C60.8937 26.5546 60.5553 25.7696 60.0901 25.06L61.7101 22.91L59.8601 21.08L57.7001 22.72C56.997 22.2834 56.2266 21.9658 55.4201 21.78L55.0901 19.09H52.4601L52.1101 21.78C51.284 21.9746 50.4987 22.3131 49.7901 22.78L47.6401 21.15L45.8101 23L47.4501 25.11C46.9874 25.8246 46.6493 26.6124 46.4501 27.44L43.8101 27.77V30.43L46.4401 30.76C46.6365 31.5886 46.9748 32.3769 47.4401 33.09L45.8601 35.25L47.6901 37L49.8301 35.39C50.5316 35.8499 51.3059 36.188 52.1201 36.39L52.4601 39H55.1201L55.4701 36.34C56.291 36.1396 57.0721 35.8015 57.7801 35.34L59.9401 37L61.7801 35.16L60.1501 33C60.595 32.3073 60.9164 31.5426 61.1001 30.74Z'
        fill='#FFD356'
        stroke='#5A5654'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M53.7899 32.69C55.7892 32.69 57.4099 31.0693 57.4099 29.07C57.4099 27.0707 55.7892 25.45 53.7899 25.45C51.7907 25.45 50.1699 27.0707 50.1699 29.07C50.1699 31.0693 51.7907 32.69 53.7899 32.69Z'
        fill='white'
        stroke='#5A5654'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

IconFilterGroup.propTypes = {
  className: PropTypes.string
}

const StyledIconFilterGroup = styled(IconFilterGroup)`
  height: 150px;
`

export default StyledIconFilterGroup
